import { InjectionToken } from '@angular/core';
import { AdyenEnvironment } from '../types/adyen-environment.type';

export const ADYEN_ENVIRONMENT = new InjectionToken<AdyenEnvironment>('Adyen environment');
